<ng-container [ngSwitch]="layout$ | async">
  <app-fresh-category-page *ngSwitchCase="layouts.Fresh" [slug]="slug"></app-fresh-category-page>
</ng-container>
